import React, { useRef } from 'react';

const ACCEPTED_TYPES = [
  'image/*',
  '.pdf',
  '.doc',
  '.docx',
  '.txt',
  '.csv',
  '.xlsx',
].join(',');

const MAX_FILE_SIZE_MB = 10;

function PaperclipIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48" />
    </svg>
  );
}

function SendIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="white">
      <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
    </svg>
  );
}

function XIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

export default function AssistantInput({ value, onChange, onSend, file, onFileChange, onFileRemove, loading }) {
  const fileInputRef = useRef(null);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!loading && value.trim()) onSend();
    }
  };

  const handleTextareaInput = (e) => {
    const el = e.target;
    el.style.height = 'auto';
    el.style.height = Math.min(el.scrollHeight, 100) + 'px';
  };

  const handleFileSelect = (e) => {
    const selected = e.target.files[0];
    if (!selected) return;
    if (selected.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      alert(`File must be under ${MAX_FILE_SIZE_MB}MB.`);
      return;
    }
    onFileChange(selected);
    // Reset so same file can be re-selected
    e.target.value = '';
  };

  const canSend = !loading && value.trim().length > 0;

  return (
    <div className="assistant-input-area">
      {file && (
        <div className="file-preview-chip">
          <PaperclipIcon />
          <span className="file-name" title={file.name}>{file.name}</span>
          <button className="chip-remove" onClick={onFileRemove} title="Remove file">
            <XIcon />
          </button>
        </div>
      )}

      <div className="input-row">
        <button
          className="attach-btn"
          onClick={() => fileInputRef.current?.click()}
          title="Attach file"
          disabled={loading}
        >
          <PaperclipIcon />
        </button>

        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          onInput={handleTextareaInput}
          placeholder="Ask anything about fashion design…"
          rows={1}
          disabled={loading}
        />

        <button className="send-btn" onClick={onSend} disabled={!canSend} title="Send">
          <SendIcon />
        </button>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept={ACCEPTED_TYPES}
        style={{ display: 'none' }}
        onChange={handleFileSelect}
      />
    </div>
  );
}
